import {isString} from 'ramda-adjunct';

import {warehouseRoutes} from '@dms/routes';
import {DmsDataGrid, queryParams} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function DirectSalesOverview() {
  const navigate = useNavigate();

  const actionCallback: ActionCallback = ({actionKey, rowId, sourceSearchParams}) => {
    switch (actionKey) {
      case 'redirectDetail':
        if (isString(rowId)) {
          navigate(
            composePath(warehouseRoutes.directSalesDetailOverview, {
              params: {id: rowId},
              queryParams: `${sourceSearchParams}&${queryParams.REDIRECT_SOURCE}=workshop-direct-sales`,
              isSearchParamsPreserved: false,
            })
          );
        }
    }
  };

  return (
    <DmsDataGrid
      gridCode="direct-sale"
      actionCallback={actionCallback}
      data-testid="directSaleDatagrid"
    />
  );
}
